import {
  type DeadlineRecurrenceChoice,
  isIsoDay,
  MAX_RENEWAL_VALIDITY_MONTHS,
} from '@prospero/shared';
import type { DocumentUploaderGate } from './consultant-document-uploader-gate';

/** Una voce per campo, nell'ordine del form: la chiave di traduzione è `create.missing.<voce>`. */
export type MissingCreateInput =
  | 'client'
  | 'document'
  | 'type'
  | 'title'
  | 'recurrence'
  | 'dueAt'
  | 'nextDueAt'
  | 'validityMonths';

export interface CreateDeadlineInputs {
  clientCount: number;
  uploaderGate: DocumentUploaderGate;
  documentTypeId: string;
  titleRequired: boolean;
  title: string | undefined;
  recurrence: DeadlineRecurrenceChoice | undefined;
  dueAt: string | undefined;
  validityMonths: number | undefined;
}

function hasValidMonths(months: number | undefined): boolean {
  return (
    months !== undefined &&
    Number.isInteger(months) &&
    months >= 1 &&
    months <= MAX_RENEWAL_VALIDITY_MONTHS
  );
}

function listMissingDates(inputs: CreateDeadlineInputs): MissingCreateInput[] {
  const { recurrence, dueAt, validityMonths } = inputs;
  if (recurrence === undefined) {
    return ['recurrence'];
  }
  if (recurrence === 'NONE') {
    return [];
  }
  const missing: MissingCreateInput[] = [];
  if (recurrence === 'RECURRING' && !hasValidMonths(validityMonths)) {
    missing.push('validityMonths');
  }
  if (!dueAt || !isIsoDay(dueAt)) {
    missing.push(recurrence === 'RECURRING' ? 'nextDueAt' : 'dueAt');
  }
  return missing;
}

/** Cosa manca per "Crea": il pulsante disattivato dice perché, come nel dialog di rinnovo. */
export function listMissingCreateInputs(inputs: CreateDeadlineInputs): MissingCreateInput[] {
  const missing: MissingCreateInput[] = [];
  if (inputs.clientCount === 0) {
    missing.push('client');
  }
  if (inputs.uploaderGate === 'documentMissing') {
    missing.push('document');
  }
  if (inputs.documentTypeId === '') {
    missing.push('type');
  }
  if (inputs.titleRequired && !inputs.title?.trim()) {
    missing.push('title');
  }
  return [...missing, ...listMissingDates(inputs)];
}
